import React, { useEffect } from 'react'
import { FormattedMessage } from "react-intl";
import { useTheme } from "react-jss";
import { formatBytes } from "../../../helpers/general";
import ProgressBar from 'react-bootstrap/ProgressBar';
import styles from "./styles";

const CustomPreview = (props) => {

  const theme = useTheme();
  const classes = styles({ theme });

  const {
    fileWithMeta: { cancel, remove, restart },
    meta: { name = '', percent = 0, size = 0, previewUrl, status, duration, validationError },
    emailColumnPresent,
    correctNumberOfCommas,
    files,
    isUpload,
    canCancel,
    canRemove,
    canRestart,
    extra: { minSizeBytes },
    setIsUploading
  } = props

  let title = `${name || '?'}`
  
  let hasError = ['error_upload_params', 'exception_upload', 'aborted'].includes(status) && canRestart || emailColumnPresent === false || correctNumberOfCommas === false;

  if (status === 'error_file_size' || status === 'error_validation') {
    hasError = true;
  }

  if (hasError) {
    setIsUploading(false);
  }

  const renderError = () => {
    if (hasError) {
      // the rest of your error logic
      switch (status) {
        case "error_file_size":
          return <span className={classes.errorMessage}>{size < minSizeBytes ? <FormattedMessage id="notifications.uploadPeople.noTravelersError" /> : <FormattedMessage id="dropzone.customPreview.toBigError" />}</span>;
        case "error_validation":
          return <span className={classes.errorMessage}>{String(validationError)}</span>;
        default:
          return <div className={classes.tryAgain} onClick={remove}><FormattedMessage id="dropzone.customPreview.tryAgain" /></div>;
      }
    }
  }

  const renderSelectedFileFailedMessage = () => {
    if (emailColumnPresent === false) {
      return (<span className={classes.errorMessage}><FormattedMessage id="notifications.uploadPeople.7001" /></span>)
    } else if (correctNumberOfCommas === false) {
      return (<span className={classes.errorMessage}><FormattedMessage id="dropzone.validation.invalidFile" /></span>)
    } else {
      return (<span className={classes.errorMessage}><FormattedMessage id="dropzone.customPreview.uploadFailed" /></span>)
    }
  }

  //note: 'error_upload' set if upload response has HTTP status code >= 400
  const responseErrorStatus = status === 'error_upload';

  return (
    <div className={hasError || responseErrorStatus || emailColumnPresent === false || correctNumberOfCommas === false ? classes.previewError : classes.preview}>
      {
        hasError || responseErrorStatus ?
          <span className={classes.fileRedIcon} />
          :
          <span className={classes.fileIcon} />
      }
      <div className={classes.content}>
        {
          hasError &&
          <div className={classes.wrapper}>
            {renderSelectedFileFailedMessage()}
            <span className={classes.cancelRedIcon} onClick={remove} />
          </div>
        }
        {
          responseErrorStatus &&
          <div className={classes.wrapper}>
            <span className={classes.errorMessage}><FormattedMessage id="dropzone.customPreview.responseErrorCode" /></span>
            <span className={classes.cancelRedIcon} onClick={remove} />
          </div>
        }
        <div className={classes.wrapper}>
          <span className={hasError || responseErrorStatus ? classes.titleError : classes.title}>{title}</span>
          {status === 'uploading' && (
            <span className={classes.cancelIcon} onClick={remove} />
          )}
          {emailColumnPresent && correctNumberOfCommas && (status === 'ready' || status === 'headers_received') && canRemove && (
            <span className={classes.cancelIcon} onClick={remove} />
          )}
          {status !== 'preparing' && status !== 'getting_upload_params' && status !== 'uploading' && status !== 'ready' && status !== 'headers_received' && canRemove && !hasError && !responseErrorStatus && (
            <span className={classes.icon} />
          )}
        </div>
        {!hasError && !responseErrorStatus && status !== 'uploading' && (
          <div className={classes.staticProgress} />
        )}
        {
          renderError()
        }
        {
          !hasError && !responseErrorStatus && status !== 'ready' &&
          <>
            <div>{formatBytes(size)}</div>
            <div className={classes.progressDiv}>
              {isUpload && (
                <>
                  <ProgressBar
                    now={status === 'done' || status === 'headers_received' ? 100 : percent}
                  />
                  <div>{percent}%</div>
                </>
              )}
            </div>
          </>
        }
      </div>

    </div>
  )
}

export default CustomPreview